(() => {
  function addListeners() {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target as HTMLElement;
        const parent = target.parentElement;

        if ('jsDropdownToggle' in target.dataset) {
          document.querySelectorAll('.dropdown-open').forEach((el: HTMLElement) => {
            if (target == el) return;

            el.classList.remove('dropdown-open');
          });
          parent?.classList.toggle('dropdown-open');
          event.stopPropagation();
        } else if (parent && 'jsDropdownToggle' in parent.dataset) {
          const grandParent = parent.parentElement;

          document.querySelectorAll('.dropdown-open').forEach((el: HTMLElement) => {
            if (grandParent == el) return;

            el.classList.remove('dropdown-open');
          });
          grandParent?.classList.toggle('dropdown-open');
          event.stopPropagation();
        } else {
          document.querySelectorAll('.dropdown-open').forEach((el: HTMLElement) => {
            if (target == el) return;

            el.classList.remove('dropdown-open');
          });
        }
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', addListeners, false);
})();
